export const DsToastDefaultProps = {
    variant: 'filled',
    icon: false,
    severity: undefined
};
